import {
  CardsComponent,
  ContactHeroBannerComponent,
  FaqComponent,
} from '@adminprodigydesign/axis';
import { Component } from '@angular/core';
import { FaqItem } from '../../../assets/data/faq-data';
import {
  ContactDetails,
  ContactInfoSections,
} from '../../../assets/data/contact-banner-data';

@Component({
  selector: 'app-contact',
  imports: [ContactHeroBannerComponent, CardsComponent, FaqComponent],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss',
})
export class ContactComponent {
  faqItem = FaqItem;
  contactDetails = ContactDetails;
  contactInfoSections = ContactInfoSections;

  cards: any = [
    {
      iconClass: 'fa-solid fa-phone',
      title: 'Emergency Call Out',
      description: 'Call us 24/7 for any emergency.',
      link: 'tel:+447506113669',
      linkText: 'Call Now',
    },
    {
      iconClass: 'fa-regular fa-comments',
      title: 'Chat with us',
      description: 'For any general enquiries.',
      link: '/contact#contact-form',
      linkText: 'Contact support',
    },
    {
      iconClass: 'fa-brands fa-instagram',
      title: 'View our Instagram',
      description: 'To see our latest projects and updates.',
      link: 'https://www.instagram.com/heattechuk',
      linkText: 'View our page',
      external: true,
    },
  ];
}
